// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"aafae1c1","outerContainer":"_76511f85","secondaryToolbar":"b4a856d8","doorHangerRight":"_69da45c8","toolbarContainer":"_794e8db1","toolbarViewerMiddle":"cf8fc20c","progressBar":"_17863524","back-to-application":"_2dc86cd2","cancelPopup":"b7d2b6fc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VirtualVideoRoom/Components/RemoveInvitationLinkPopup/styles.styl
// module id = 5165
// module chunks = 39